import { Layout } from "@/components/Layout";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "F&L Cars is committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data.",
    sections: [
      ["Information We Collect", "We collect information you provide during registration and financing applications, including name, contact details, date of birth, employment information, and uploaded documents."],
      ["How We Use Your Information", "Your information is used solely to process financing applications, manage contracts and payments, and communicate with you about your account."],
      ["Document Storage", "Sensitive documents such as your driver's license and proof of address are stored in private, encrypted storage and are never publicly accessible. Access is restricted to authorized personnel only."],
      ["Data Security", "We implement bank-grade security measures, including encryption, secure sessions, and role-based access controls to protect your data."],
      ["Your Rights", "You may access, update, or request deletion of your personal information at any time by contacting us."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "By using the F&L Cars platform, you agree to the following terms and conditions.",
    sections: [
      ["Use of Service", "The F&L Cars platform is provided for browsing vehicle inventory and submitting financing applications. You agree to provide accurate information."],
      ["Financing Applications", "Submission of a financing application does not guarantee approval. All applications are subject to review and a formal decision by our finance team."],
      ["Demo Data Notice", "Certain vehicle listings are clearly marked as 'Demo Data' and are illustrative only. They do not represent real inventory, VINs, or specifications."],
      ["Account Responsibility", "You are responsible for maintaining the confidentiality of your account and for all activity under it."],
      ["Limitation of Liability", "F&L Cars is not liable for any indirect damages arising from the use of this platform."],
    ],
  },
  "financing-disclosure": {
    title: "Financing Disclosure",
    intro: "Important information regarding financing estimates and agreements on the F&L Cars platform.",
    sections: [
      ["Estimates Only", "All results produced by our financing calculator are estimates only. They do not constitute a financing offer, pre-approval, or binding agreement of any kind."],
      ["Minimum Down Payment", "The minimum down payment is 10% of the vehicle price. Customers may elect a higher down payment to reduce their monthly payment. Applications below the configured minimum cannot be processed."],
      ["Maximum Term", "The maximum financing term is 48 months. Available terms are 12, 18, 24, 30, 36, 42, and 48 months."],
      ["APR", "The Annual Percentage Rate (APR) used in estimates is indicative. Your final APR is determined upon review and confirmed in a formally approved financing agreement."],
      ["Formal Approval", "Financing terms become binding only upon a formally approved and executed financing agreement between you and F&L Cars."],
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  return (
    <Layout>
      <div className="border-b border-slate-200 bg-[#E3ECFB] py-16">
        <div className="container-x max-w-3xl">
          <h1 className="font-display text-4xl font-extrabold text-slate-900 lg:text-5xl">{c.title}</h1>
          <p className="mt-4 text-slate-600">{c.intro}</p>
          <p className="mt-2 text-xs text-slate-600">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long" })}</p>
        </div>
      </div>
      <div className="container-x max-w-3xl py-12">
        <div className="space-y-8">
          {c.sections.map(([t, d], i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-bold text-slate-900">{i + 1}. {t}</h2>
              <p className="mt-2 leading-relaxed text-slate-600">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
